import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const title = 'Textarea';
export const _frontmatter = {};
const layoutProps = {
  title,
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "textarea"
    }}>{`Textarea`}</h1>
    <p>{`Accessible and themeable form textarea component.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { Label, Textarea } from '@rebass/forms'
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Box>
  <Label htmlFor='comment'>Comment</Label>
  <Textarea
    id='comment'
    name='comment'
  />
</Box>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      